export function createEncounterHistoryStore(config) {
    const { key, event, pingKey, max = 10, legacyKeys = [] } = config;
    function migrateLegacyHistory() {
        if (typeof window === "undefined")
            return;
        try {
            const existing = localStorage.getItem(key);
            if (existing)
                return;
            for (const legacyKey of legacyKeys) {
                const legacyValue = localStorage.getItem(legacyKey);
                if (!legacyValue)
                    continue;
                localStorage.setItem(key, legacyValue);
                return;
            }
        }
        catch {
            // ignore storage errors
        }
    }
    function emitHistoryChanged() {
        if (typeof window === "undefined")
            return;
        window.dispatchEvent(new CustomEvent(event));
        try {
            localStorage.setItem(pingKey, String(Date.now()));
        }
        catch {
            // ignore storage errors
        }
    }
    function loadHistory() {
        migrateLegacyHistory();
        try {
            const raw = localStorage.getItem(key);
            const arr = raw ? JSON.parse(raw) : [];
            return Array.isArray(arr) ? arr : [];
        }
        catch {
            return [];
        }
    }
    function saveHistory(list) {
        try {
            localStorage.setItem(key, JSON.stringify(list.slice(-max)));
            emitHistoryChanged();
        }
        catch {
            // ignore storage errors
        }
    }
    function upsertLatest(snap) {
        const list = loadHistory();
        const last = list[list.length - 1];
        if (!last || last.id !== snap.id) {
            list.push(snap);
            saveHistory(list);
        }
    }
    function removeById(id) {
        const list = loadHistory();
        const next = list.filter(x => x.id !== id);
        saveHistory(next);
    }
    function clearAllHistory() {
        try {
            localStorage.removeItem(key);
            emitHistoryChanged();
        }
        catch {
            // ignore storage errors
        }
    }
    function rollingAvg(n = 3, excludeId) {
        const list = loadHistory().filter(x => x.id !== excludeId);
        const take = list.slice(-n);
        if (take.length === 0)
            return null;
        const base = take.reduce((a, x) => ({
            talkClinicianPct: a.talkClinicianPct + x.talkClinicianPct,
            talkPatientPct: a.talkPatientPct + x.talkPatientPct,
            openPct: a.openPct + x.openPct,
            open: a.open + x.open,
            closed: a.closed + x.closed,
        }), {
            talkClinicianPct: 0,
            talkPatientPct: 0,
            openPct: 0,
            open: 0,
            closed: 0,
        });
        const iAgg = take.reduce((a, x) => {
            if (typeof x.interruptionsCount === "number") {
                a.sum += x.interruptionsCount;
                a.k++;
            }
            return a;
        }, { sum: 0, k: 0 });
        const eAgg = take.reduce((a, x) => {
            if (typeof x.empathyCount === "number") {
                a.sum += x.empathyCount;
                a.k++;
            }
            return a;
        }, { sum: 0, k: 0 });
        const k = take.length;
        const result = {
            count: k,
            talkClinicianPct: +(base.talkClinicianPct / k).toFixed(1),
            talkPatientPct: +(base.talkPatientPct / k).toFixed(1),
            openPct: +(base.openPct / k).toFixed(1),
            open: Math.round(base.open / k),
            closed: Math.round(base.closed / k),
        };
        if (iAgg.k)
            result.interruptionsCount = +(iAgg.sum / iAgg.k).toFixed(1);
        if (eAgg.k)
            result.empathyCount = +(eAgg.sum / eAgg.k).toFixed(1);
        return result;
    }
    return {
        HISTORY_KEY: key,
        HISTORY_EVT: event,
        HISTORY_PING_KEY: pingKey,
        loadHistory,
        saveHistory,
        upsertLatest,
        removeById,
        clearAllHistory,
        rollingAvg,
    };
}
